import { createContext, useContext, JSX, createMemo, Accessor } from 'solid-js';

type Props = {
  children: JSX.Element;
  /**
   * The feature codes for the available advanced capabilities
   * @example ['FEA-USERS', 'FEA-CONN-MAX-FORMS']
   */
  tierFeatures?: string[];
};

/**
 *  Manages the tier features currently available to the user.
 *
 *  @param {string[]} props.tierFeatures The feature codes for
 *    the available advanced capabilities
 *    @example ['FEA-USERS', 'FEA-CONN-MAX-FORMS']
 */
export function TieringProvider(props: Props): JSX.Element {
  const tierFeatures = createMemo<string[]>(() => props.tierFeatures ?? []);

  return (
    <TieringContext.Provider
      value={{
        tierFeatures: tierFeatures,
      }}
    >
      {props.children}
    </TieringContext.Provider>
  );
}

export interface TieringState {
  tierFeatures: Accessor<string[]>;
}

export const TieringContext = createContext<TieringState>();

export const useTiering = (): TieringState => {
  const context = useContext(TieringContext);
  if (!context) {
    throw new Error('useTiering must be used within a TieringProvider');
  }
  return context;
};
